module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding-29cbaa03c1213efb7cf8e46fdfc83d27.jpg";